<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        ساختاربندی گروه های کالایی
        <template v-slot:avatar>
          <q-avatar icon="account_tree"/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <q-input v-model="searchKey" filled label="جستجو..."/>
    </q-card-section>
    <q-card-section>
      <q-tree
          default-expand-all
          icon="category"
          accordion
          :filter="searchKey"
          :nodes="unflatten(groupList)"
          node-key="id"
          label-key="Group_Name"
      >
        <template v-slot:default-header="prop">
          {{ prop.node.Group_Name }}
          <q-btn icon="add" flat round color="green"
                 @click.stop
                 @click="addGroup(prop.node)"/>
          <q-btn icon="edit" flat round color="green"
                 @click.stop
                 v-if="prop.node.parentid"
                 @click="editGroup(prop.node)"/>
          <q-btn icon="delete"
                 flat
                 round
                 color="red"
                 @click.stop
                 @click="onDelete(prop.node)"
                 v-if="prop.node.parentid && prop.node.children.length===0"/>
        </template>
      </q-tree>
    </q-card-section>

    <q-dialog v-model="goodsGroupTreeDialog" :full-width="$q.screen.lt.md">
      <GoodsGroupTree :goods-group-info="selectedGroup" :is-dialog="true" @changed-goods-group="onsubmit"/>
    </q-dialog>
  </q-card>
</template>

<script>

import {mapActions} from "vuex";
import GoodsGroupTree from "@/components/GoodsGroup/GoodsGroupTree.vue";

export default {
  name: "GoodsGroupTreeManagement",
  components: {GoodsGroupTree},
  data() {
    return {
      goodsGroupTreeDialog: false,
      groupList: [],
      treeGroupList: [],
      searchKey: undefined,
      selectedGroup: undefined
    }
  },
  methods: {
    ...mapActions({
      getGroupTree: 'Products/getGroupTree',
      addGoodsGroup: 'Products/addGoodsGroupTree',
      deleteGoodsGroup: 'Products/deleteGoodsGroupTree'
    }),
    addGroup(parentNode) {
      this.selectedGroup = {
        parentid: parentNode.id,
        Group_Name: undefined
      }
      this.goodsGroupTreeDialog = true
    },
    editGroup(node) {
      this.selectedGroup = node
      this.goodsGroupTreeDialog = true
    },
    onsubmit(args) {
      this.addGoodsGroup(args).then((res) => {
        if ('id' in args) {
          const foundedIndex = this.groupList.findIndex(item => item.id === args.id)
          this.groupList.splice(foundedIndex, 1)
          this.groupList.push(res[0])
        } else {
          this.groupList.push(res[0])
        }
      })
      this.goodsGroupTreeDialog = false
    },
    onDelete(args) {
      this.deleteGoodsGroup(args).then((res) => {
        if (res.result === 1) {
          const foundedIndex = this.groupList.findIndex(item => item.id === args.id)
          this.groupList.splice(foundedIndex, 1)
        }
      })
    },
    unflatten(arr) {
      let tree = [],
          mappedArr = {},
          arrElem,
          mappedElem;
      for (let i = 0, len = arr.length; i < len; i++) {
        arrElem = arr[i];
        mappedArr[arrElem.id] = arrElem;
        mappedArr[arrElem.id]['children'] = [];
      }
      for (const id in mappedArr) {
        if (Object.prototype.hasOwnProperty.call(mappedArr, id)) {
          mappedElem = mappedArr[id];
          if (mappedElem.parentid) {
            mappedArr[mappedElem['parentid']]['children'].push(mappedElem);
          } else {
            tree.push(mappedElem);
          }
        }
      }
      return tree;
    }
  },
  created() {
    this.getGroupTree().then((res) => {
      this.groupList = res
      this.treeGroupList = this.unflatten(this.groupList)
    })
  }
}
</script>

<style scoped>

</style>